import      React from 'react';
import {    TFunction, useTranslation,
} from "react-i18next";
import      styles 
  from './index.module.scss';
import {    BarGraphStacked,
            LineGraphStacked,
            BarGraph,
} from '../../../../components/graphs';
import { PieGraph } from '../../../../components/graphs/pieGraph';
import { ScatterGraphStacked, DataStackedAttributes } from '../../../../components/graphs/scatterGraph';
import {    EmailIcon, 
            PhoneIcon, 
            WebsiteIcon, 
} from '../../../../components/icons';
import {    IconWithLink 
} from '../../../../components/iconWithLink';
import {    IconWithTextAndCopyButton, 
} from '../../../../components/iconWithTextAndCopyButton';
import {    AccreditationCategories,
} from '../../../../consts/accreditations';
import {    Language,
} from "../../../../consts/languages";
import {    UserLanguage,
} from "../../../../hooks/raiseUser";
import {    CompanyPage, CompanyPageBid,
} from "../../../../hooks/slices/companySlice";
import {    SearchResponse,
} from '../../../../hooks/slices/tenderSearchSlice';
import {    CompanyDetailsContentItem,
} from "../../../../types/company";
import {    CompanyUtil,
} from "../../../../utils/company";
import {    DateUtil, 
} from '../../../../utils/date';
import {    StringUtil,
} from "../../../../utils/strings";
import {    ResponsiveContainer,
            ComposedChart,
            XAxis,
            YAxis,
            Line,
            Bar,
            Tooltip as RechartsTooltip,
            ScatterChart,
            Scatter,
            CartesianGrid,
            ReferenceLine,
            TooltipProps
} from 'recharts';
import { GraphTooltip } from '../../../../components/graphs/shared/GraphTooltip';
import { formatNumberShort } from '../../../../utils/format';
import moment from 'moment';
import {
    calculateMetricByYear,
    calculateYoYChange,
    getSimpleYoYSubtitleProps,
    reduceBidsByYear,
    getCompanyAccreditations,
    parseAccreditation,
    parsedAccreditationListToDataStructure,
    parseAccreditationForSummaryGraph,
    parseAccreditationForDetailsGraph,
    AccreditationsDataStructure,
    LetterDataStructure,
    NumbersDataStructure,
    AccreditationGraphData,
    parsedAccreditationAttributes
} from './infoUtils';

// Import the newly extracted component
import { MainInfoCard } from './components/MainInfoCard';
// Import the newly extracted component
import { ContactInfoCard } from './components/ContactInfoCard';
// Import the newly extracted component
import { ActivitiesCard } from './components/ActivitiesCard';
// Import the newly extracted component
import { AccreditationsCard } from './components/AccreditationsCard';

export interface TabPanelInfoProps extends React.HTMLAttributes<HTMLDivElement> {
    companyPage: CompanyPage | null;
    tendersWon: SearchResponse | null;
    tendersParticipatedIn: SearchResponse | null;
    isGovernment: boolean;
}
export const TabPanelInfo: React.FC<TabPanelInfoProps> = ({ 
    companyPage,
    tendersWon,
    tendersParticipatedIn,
    isGovernment,
    ...props 
}) => {
    let {t, i18n} = useTranslation();
    let language: Language = UserLanguage(i18n.language);

    if (!companyPage) return <></>; //TODO make info  skeleton

    const combinedActivities: string[] = CompanyUtil.getCompanyActivities(companyPage.activities, language)
        .map(activity => activity)
        .filter(StringUtil.distinct)
        .filter(activity => activity.trim() !== '')
    ;
    const accreditations: CompanyDetailsContentItem[] = getCompanyAccreditations(companyPage);
    const contactInformationAvailable: boolean = companyPage.website != null || companyPage.phone != null || companyPage.email != null;

    return (<>
        <div className={styles["container-info"]}>
            <MainInfoCard companyPage={companyPage} t={t} language={language}/>
            {contactInformationAvailable && <ContactInfoCard companyPage={companyPage} t={t}/>}
            {combinedActivities.length > 0 && <ActivitiesCard combinedActivities={combinedActivities} t={t} language={language}/>}
            {!isGovernment && accreditations.length > 0 && <AccreditationsCard accreditations={accreditations} t={t}/>}
       </div>
    </>);
}